<template>
	<div id="app">
		<router-view></router-view>
	</div>
</template>

<script>
	import index from './views/index.vue'

	export default {
		name: 'app',
		components: {
			index
		}
	}
</script>

<style>
	#app {
		font-family: Microsoft YaHei;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		text-align: center;
		color: #2c3e50;
		height: 100%;
	}
</style>